import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import Layout from "./components/Layout";
import AdminLayout from "./components/Layout/AdminLayout";
import RequireAuth from "./components/Auth/RequireAuth";
import Home from "./components/Pages/Home";
import About from "./components/Pages/About";
import Appointments from "./components/Pages/Appointments";
import Contact from "./components/Pages/Contact";
import ErrorPage from "./components/Pages/ErrorPage";
import SignUp from "./components/Pages/SIgnUp";
import Profile from "./components/Pages/Profile";
import OurServices from "./components/Pages/OurServices";
import Admin from "./components/Pages/Admin";
import Users from "./components/Pages/Users";
import Bookings from "./components/Pages/Bookings";
import Services from "./components/Pages/Services";
import AdminProfile from "./components/Pages/AdminProfile";
import Gallery from "./components/Pages/Gallery";
import { initGA, trackPageView } from "./helpers/lib/analytics";

function App() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname + search);
  }, [pathname, search]);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<OurServices />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="contact" element={<Contact />} />
          <Route path="signup" element={<SignUp />} />
          <Route
            path="profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
        </Route>

        <Route
          path="/admin"
          element={
            <RequireAuth adminOnly>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Admin />} />
          <Route path="users" element={<Users />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="services" element={<Services />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="gallery" element={<Gallery />} />
        </Route>

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
